var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelerIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.4194C0 11.1646 10.7452 0.419434 24 0.419434C37.2548 0.419434 48 11.1646 48 24.4194C48 37.6743 37.2548 48.4194 24 48.4194C10.7452 48.4194 0 37.6743 0 24.4194Z",
    fill: "#F4EBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.4194H19.8C18.1198 15.4194 17.2798 15.4194 16.638 15.7464C16.0735 16.034 15.6146 16.493 15.327 17.0575C15 17.6992 15 18.5393 15 20.2194V28.6194C15 30.2996 15 31.1397 15.327 31.7814C15.6146 32.3459 16.0735 32.8048 16.638 33.0925C17.2798 33.4194 18.1198 33.4194 19.8 33.4194H28.2C29.8802 33.4194 30.7202 33.4194 31.362 33.0925C31.9265 32.8048 32.3854 32.3459 32.673 31.7814C33 31.1397 33 30.2996 33 28.6194V25.4194M24 20.4194H28V24.4194M27.5 15.9194V14.4194M31.4393 16.9801L32.5 15.9194M32.5103 20.9194H34.0103M15 25.7665C15.6519 25.8672 16.3199 25.9194 17 25.9194C21.3864 25.9194 25.2653 23.747 27.6197 20.4194",
    stroke: "#7F56D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelerIcon3);
export default __webpack_public_path__ + "static/media/traveler_icon_3.89cbae541b954cfcc2188d64933c789b.svg";
export { ForwardRef as ReactComponent };